


































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiInputFile extends BaseComponent {
  @Prop()
  value:any;

  @Prop({ default: 'Arquivo' })
  private label: string;

  @Prop()
  private urlDownloadFile: string;

  @Prop()
  private originalFileName: string;

  @Prop({ default: false })
  private showDownload: string;

  @Prop({ default: 'Selecione um arquivo' })
  private placeholder: string;

  @Prop({ default: '*/*' })
  private accept: string;

  @Prop({ default: 10 })
  private maxSizeMb: number;

  @Prop({ default: false })
  private required?: boolean;
  @Prop({ default: false })
  private disabled?: boolean;
  @Prop({ default: false })
  private readonly?: boolean;
  @Prop({
    default: () => [],
  })
  private rules?: any[];

  private fileName: string = null;
  private fileObject: any;
  private url: any;
  private sizeMb: number;

  private errorMessages: string[] = [];

  @Watch('value')
  onValueChange(v) {
    if (!v) {
      this.fileName = null;
    }
  }

  @Watch('fileName')
  private fileNameChange(fileName: string) {
    if (!fileName) {
      this.$emit('input', null);
      this.clearInputFile(this.$refs['fileInput']);
      this.errorMessages = [];
    }
  }

  @Watch('originalFileName', { immediate: true })
  private onOriginalFileNameChange(ofn: string) {
    this.fileName = ofn;
  }

  onPickFile() {
    if (this.disabled || this.readonly) {
      return;
    }
    let elem: any = this.$refs['fileInput'];
    elem.click();
  }

  onFilePicked(event) {
    const files = event.target.files;
    if (files[0] !== undefined) {
      this.fileName = files[0].name;
      // Check validity of file
      if (this.fileName.lastIndexOf('.') <= 0) {
        return;
      }
      // If valid, continue
      const fr = new FileReader();
      fr.readAsDataURL(files[0]);
      fr.addEventListener('load', () => {
        this.url = fr.result;
        this.fileObject = files[0]; // this is an file that can be sent to server...
        this.sizeMb = (this.fileObject as File).size / 1024.0 / 1024.0;
        if (this.sizeMb > this.maxSizeMb) {
          this.errorMessages.push(
            `Tamanho máximo de ${this.maxSizeMb}MB excedido (${this.decimalFormatHelper(this.sizeMb)}MB)`,
          );
          this.$emit('input', null);
          this.$emit('change', null);
        } else {
          this.errorMessages = [];
          this.$emit('input', this.fileObject);
          this.$emit('change', this.fileObject);
        }
      });
    } else {
      this.errorMessages = [];
      this.fileName = '';
      this.fileObject = null;
      this.url = '';
      this.$emit('input', null);
      this.$emit('change', null);
    }
  }

  clearInputFile(f) {
    this.$emit('delete');
    this.$emit('input', null);
    this.$emit('change', null);
    if (f.value) {
      try {
        f.value = ''; //for IE11, latest Chrome/Firefox/Opera...
      } catch (err) {}
      if (f.value) {
        //for IE5 ~ IE10
        var form = document.createElement('form'),
          parentNode = f.parentNode,
          ref = f.nextSibling;
        form.appendChild(f);
        form.reset();
        parentNode.insertBefore(f, ref);
      }
    }
  }

  isShowDownloadFile() {
    return this.showDownload && !!this.urlDownloadFile;
  }

  downloadFile() {
    if (this.urlDownloadFile) {
      window.open(this.urlDownloadFile, 'downloadFileLink');
    } else {
      this.$emit('download');
    }
  }
}
